// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"2f92335e","142":"cc6294ac","281":"37ebfe8f","934":"43ac5148"}[chunkId] + ".chunk.js";
};